import React, { createContext, useState } from 'react';

export interface ErrorCountContextValue {
  errorCount: number;
  addErrorField: (field: string) => void;
  removeErrorField: (field: string) => void;
}

export const ErrorCountContext = createContext<ErrorCountContextValue>({
  errorCount: 0,
  addErrorField: () => {},
  removeErrorField: () => {},
});

const ErrorCountProvider: React.FC = ({ children }) => {
  const [errorFields, setErrorFields] = useState(new Map<string, boolean>());

  const addErrorField = (field: string) => {
    const errorFieldsCopy = new Map(errorFields);
    if (!errorFieldsCopy.has(field)) {
      errorFieldsCopy.set(field, true);
      setErrorFields(errorFieldsCopy);
    }
  };
  const removeErrorField = (field: string) => {
    const errorFieldsCopy = new Map(errorFields);
    if (errorFieldsCopy.has(field)) {
      errorFieldsCopy.delete(field);
      setErrorFields(errorFieldsCopy);
    }
  };

  return (
    <ErrorCountContext.Provider
      value={{ errorCount: errorFields.size, addErrorField, removeErrorField }}
    >
      {children}
    </ErrorCountContext.Provider>
  );
};

export default ErrorCountProvider;
